module.exports = "/images/France.png?8565f022d3e9cadda2083f5ea9289924";